/*
 * Get-categories.ts
 * Description: Includes the declaration
 * of the function for getting a list of all categories
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex store
import {store} from '@/config/plugins';

/**
 * Getting a list of categories
 *
 * @return {Object} Promise - a list of categories
 * @param {String} slug - id of a restaurant
 */
export function getCategories(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/menu-categories',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            store.dispatch('setResponse', response.data.data);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
